
  import { API_BASE_URL } from "~/utils/constants";
export default {
  name: 'layout',
  components: {
  },
  computed: {
  },
    data() {
        return {
            companyName: '',
        }
    },
  methods: {
    startLoading(){
      this.$refs.sidebar.startLoading();
    },
    endLoading(){
      this.$refs.sidebar.endLoading();	
    }
  }
}
